<template>
    <modal name="register" v-bind:class="{ 'is-custom': step == 1 }" class="dd-m-modal dd-m-modal--auth">
        <button v-on:click="hide()" type="button" class="dd-m-auth__close-btn">
            <i class="dd-m-icon icon-close"></i>
        </button>

        <auth-register v-if="step === 1"></auth-register>

        <auth-register-success v-if="step === 2"></auth-register-success>
    </modal>
</template>
<script>
    import AuthRegister from "./auth-register";
    import AuthRegisterSuccess from "./auth-register-success";

    export default {
        name: 'modal-register',
        components: {AuthRegisterSuccess, AuthRegister},
        props: ['name'],
        mounted() {
            PubSub.subscribe('openRegisterModal', (msg, param) => {
                if (param) {
                    this.step = 1;
                }
                this.show();
            });
            PubSub.subscribe('closeRegisterModal', () => this.hide());
            PubSub.subscribe('updateRegisterStep', (msg, data) => this.goTo(data.step));
        },
        data: () => {
            return {
                step: 1,
            }
        },
        methods: {
            show() {
                this.$modal.show('register');
            },
            hide() {
                this.$modal.hide('register');
            },
            goTo(step) {
                this.step = step;
            },
        }
    }
</script>



// WEBPACK FOOTER //
// resources/site/js/components/auth/modal-register.vue